module.exports = __webpack_public_path__ + "img/golf-default-banner.fea2dd82.png";